<template>
  <header v-if="$store.state.user?.data" class="header">
    <nav class="menu header__menu">
      <ul>
        <li>
          <router-link to="/account" active-class="active" exact="true" @click="setDisable">
            <svg width="20px" height="20px"><use xlink:href="#icon-user"/></svg>
            <span>Hey, {{ $store.state.user.data ? $store.state.user.data.name : 'Guest' }}!</span>
          </router-link>
        </li>

        <li>
          <router-link to="/" active-class="active" exact="true" @click="setDisable">
            <svg width="20px" height="20px"><use xlink:href="#icon-home"/></svg>
            <span>Home</span>
          </router-link>
        </li>

        <li>
          <router-link to="/settings" active-class="active" @click="setDisable">
            <svg width="20px" height="20px"><use xlink:href="#icon-settings"/></svg>
            <span>Settings</span>
          </router-link>
        </li>

        <li>
          <a @click.prevent="logout">
            <svg width="20px" height="20px"><use xlink:href="#icon-turn-off"/></svg>
            <span>Log Out</span>
          </a>
        </li>
      </ul>
    </nav>
  </header>
</template>



<script>
  export default {
    methods: {
      setDisable() {
        document.querySelector('.header').classList.add('disable')
        setTimeout(() => {
          document.querySelector('.header').classList.remove('disable')
        }, 500)
      },



      logout() {
        this.$router.push({
          name: 'login',
          query: {
            account: 'logout'
          }
        })
      }
    }
  }
</script>
